import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";

export default function PaymentPage() {
    const [searchParams] = useSearchParams();
    const [ready, setReady] = useState(false);
    const [accepted, setAccepted] = useState(false);

    const sessionId = searchParams.get("session");

    useEffect(() => {
        if (!sessionId) return;

        const script = document.createElement("script");
        script.src = "https://ap-gateway.mastercard.com/static/checkout/checkout.min.js";
        script.setAttribute("data-error", "errorCallback");
        script.setAttribute("data-cancel", "cancelCallback");

        script.onload = () => {
            setReady(true);
        };

        document.body.appendChild(script);

        window.errorCallback = function (error) {
            alert("Payment Error ❌");
            console.log(error);
        };

        window.cancelCallback = function () {
            alert("Payment Cancelled ❌");
        };
    }, [sessionId]);

    const startPayment = () => {
        if (!accepted) {
            alert("⚠️ Please accept Terms & Conditions");
            return;
        }

        if (!window.Checkout || !sessionId) {
            alert("Payment not ready");
            return;
        }

        window.Checkout.configure({
            session: {
                id: sessionId
            }
        });

        window.Checkout.showPaymentPage();
    };

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <h2 style={styles.title}>🔒 Secure Payment</h2>

                <p style={styles.desc}>
                    You will be redirected to a secure payment gateway powered by Mastercard.
                </p>

                {/* Checkbox */}
                <div style={styles.checkboxRow}>
                    <input
                        type="checkbox"
                        checked={accepted}
                        onChange={() => setAccepted(!accepted)}
                    />
                    <label style={styles.label}>
                        I agree to the{" "}
                        <Link to="/terms" style={styles.link}>
                            Terms & Conditions
                        </Link>{" "}
                        and{" "}
                        <Link to="/privacy" style={styles.link}>
                            Privacy Policy
                        </Link>
                    </label>
                </div>

                {/* Button */}
                <button
                    onClick={startPayment}
                    disabled={!ready}
                    style={{
                        ...styles.button,
                        opacity: ready ? 1 : 0.6,
                        cursor: ready ? "pointer" : "not-allowed"
                    }}
                >
                    {ready ? "Pay Now" : "Preparing Payment..."}
                </button>
            </div>
        </div>
    );
}

const styles = {
    page: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "#f5f7fb"
    },
    card: {
        background: "#fff",
        padding: "40px",
        borderRadius: "12px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
        width: "400px",
        textAlign: "center"
    },
    title: {
        marginBottom: "10px"
    },
    desc: {
        fontSize: "14px",
        color: "#666",
        marginBottom: "20px"
    },
    checkboxRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        textAlign: "left",
        marginBottom: "20px"
    },
    label: {
        fontSize: "13px",
        color: "#333"
    },
    link: {
        color: "#007bff",
        textDecoration: "none"
    },
    button: {
        width: "100%",
        padding: "12px",
        background: "#000",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        fontSize: "16px"
    }
};